// extracted by mini-css-extract-plugin
export var active = "_r6-1";
export var circle = "_r6-0";
export var completed = "_r6-2";
export var connector = "_r6-4";
export var connectorCompleted = "_r6-7";
export var connectorSpacer = "_r6-5";
export var iconStrokeOverride = "_r6-8";
export var labelContainer = "_r6-6";
export var pending = "_r6-3";